






















































































import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { checkMobile } from '../../utils/utils'
import theme from '../../utils/theme'
import HeaderUser from './HeaderUser.vue'
import HeaderNotification from './HeaderNotification.vue'
import HeaderLeftMenuMobile from './HeaderLeftMenuMobile.vue'
import HeaderLeftMenuWeb from './HeaderLeftMenuWeb.vue'
import ButtonReload from '../atoms_molecules/ButtonReload.vue'
import { userState } from '../../stores/user'
import { headerState } from '../../stores/header'
import { menuState } from '../../stores/menu'
import Menu from '../../../api/v2/models/menu'
import { ROUTER_NAME } from '../../router'
import CartApi from '../../../api/v2/api/cart'

const cartApiInstance = new CartApi()

@Component({
  components: {
    HeaderNotification,
    HeaderUser,
    HeaderLeftMenuMobile,
    HeaderLeftMenuWeb,
    ButtonReload
  }
})
export default class HeaderPageDefault extends Vue {
  ROUTER_NAME = ROUTER_NAME
  mobile: boolean = checkMobile()

  theme = theme
  drawer = true
  right = null
  left = null

  cartItemCount: number = 0
  cartUpdateInterval: number | null = null

  get user() {
    return userState.user
  }

  get schoolSetting() {
    return headerState.schoolSetting
  }

  get headerTitle() {
    return headerState.headerTitle
  }

  get headerNavTextColor() {
    if (this.schoolSetting) {
      return this.schoolSetting.navTextColor
    }
  }

  get hamburgerColor() {
    if (this.schoolSetting) {
      return `color: ${this.schoolSetting.hamburgerColor}`
    } else {
      return "color: white"
    }
  }

  get headerNavColor() {
    if (this.schoolSetting) {
      return this.schoolSetting.navColor
    } else {
      return this.theme.headerBackgroundColor
    }
  }

  async created() {
    this.drawer = !this.mobile
    await headerState.getSchoolSetting()
    this.fetchCartData()

    this.cartUpdateInterval = window.setInterval(() => {
      this.fetchCartData()
    }, 30000) // Check every 30 seconds
  }

  beforeDestroy() {
    if (this.cartUpdateInterval) {
      clearInterval(this.cartUpdateInterval)
    }
  }

  async fetchCartData() {
    this.cartItemCount = await cartApiInstance.getCartItemCount()
  }

  goToCart() {
    window.location.href = '/purchase/cart'
  }

  redirect(router) {
    this.$router.push(router)
  }

  reload() {
    this.$router.go(this.$router.currentRoute as any)
  }

  get menus() {
    return menuState.filteredMenus
  }

  get pageTitle() {
    return this.$route.meta ? this.$route.meta.title : null
  }

  toMenu(menu: Menu) {
    if ((!menu.kbn.includes("LINK") && (menu.url != "")) || menu.isTargetBlank) {
      window.open(menu.url, '_blank')
    } else {
      window.location.href = menu.url
    }
  }

  toExamShow(){
    if (this.user && this.user != null && this.user.isGuestExamOnly) {
      location.href = `/exams/${this.$route.params.examId}`
      return
    }
  }
}
